import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="paddin">
        <div className="credits">
          <h4>Credits - Unsplash</h4>
        </div>
        <div className="regulus">
          <h4>
            By&nbsp;
            <a href="https://chethas.vercel.app">Regulus</a>
          </h4>
        </div>
      </div>
    </div>
  );
};

export default Footer;
